import { render, staticRenderFns } from "./LifetimeValue.vue?vue&type=template&id=f535c21c&"
import script from "./LifetimeValue.vue?vue&type=script&lang=js&"
export * from "./LifetimeValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports